const THEME_STORAGE_KEY = 'fs.discovery.theme'

const TOGETHER_BACKGROUND_LIGHT = '#fefefe'
const TOGETHER_BACKGROUND_DARK = '#0d0f10'

export function isTogetherDarkTheme() {
  try {
    const preference = JSON.parse(window.localStorage.getItem(THEME_STORAGE_KEY))
    if (preference === 'dark') return true
    if (preference === 'light') return false
  } catch {
    // Unset or unreadable: fall through to the system setting.
  }

  try {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  } catch {
    return false
  }
}

export function getTogetherBackground() {
  return isTogetherDarkTheme() ? TOGETHER_BACKGROUND_DARK : TOGETHER_BACKGROUND_LIGHT
}
